import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import UnfulfilledOrdersLayer from "../../components/orders/UnfulfilledOrdersLayer";

const UnfulfilledOrdersPage = () => {
    return (
        <MasterLayout>
            <UnfulfilledOrdersLayer />
        </MasterLayout>
    );
};

export default UnfulfilledOrdersPage;
